import { Outlet } from 'react-router';

import { Toaster } from '@mds/shared/ui/shadcn/sonner';

import BackToTop from '@/components/layout/back-to-top';
import SiteHeader from '@/components/layout/site-header';
import SiteFooter from '@/components/layout/site-footer';

export default function RootLayout() {
  return (
    <div className="flex min-h-svh flex-col">
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <BackToTop />
      {/* One mount for the whole app — every `notify()` call anywhere lands here. */}
      <Toaster />
    </div>
  );
}
